import * as React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Card from "../components/card"

const IndexPage = ({ data }) => {
  const posts = data.allMarkdownRemark.nodes

  return (
    <Layout pageTitle="Home">
      <ol className="post-index" style={{ listStyle: `none` }}>
        {posts.map((post) => {
          return (
            <li key={post.fields.slug}>
              <Card postData={post.frontmatter} linkTo={post.fields.slug} />
            </li>
          )
        })}
      </ol>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  {
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: ASC }) {
      nodes {
        frontmatter {
          title
          image {
            childImageSharp {
              gatsbyImageData(width: 400)
            }
          }
        }
        fields {
          slug
        }
      }
    }
  }
`
